import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RedirectAction from 'yoda-app-shell/lib/action/RedirectAction';
import * as notificationDetailsActions from '../../../../actions/NotificationDetailsActions';
import * as actions from '../../../../actions/CAMDashboardActions';
// eslint-disable-next-line import/no-named-as-default
import Preferences from '../../../../components/Preferences/Preferences';

function mapStateToProps(state) {
    const deviceType = state.context.deviceType.isDesktop ? 'desktop' : 'mobile';
    return {
        notification: state.notificationDetails ? state.notificationDetails : {},
        deviceType,
        messagesTexts: state.context.messagesTexts.notificationPreferences,
        preferences: state.context.preferences,
        featureFlags: state.context.featureFlags,
        headers: state.context.headers,
    };
}

const mapDispatchToProps = (dispatch) => ({
    camActions: bindActionCreators(actions, dispatch),
    actions: bindActionCreators(notificationDetailsActions, dispatch),
    redirectAction: bindActionCreators(RedirectAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Preferences);
